import { nsXsi } from '@qdabra/forms-shared/xmlNamespaces';
import { isElement } from 'func-xml';
import { setNodeValue, xmlToString } from '../../../xmlUtility';
import { getDataSource } from './qRules.dataSource.helpers';
import { selectNodeListFromXPathEngine } from './qRules.utility';

const errorInvalidPath =
    'Error: No nodes were found using the specified XPath.';

export function checkValidNode(node, errorMessage) {
    if (!node) {
        throw new Error(errorMessage);
    }

    return node;
}

export const getValidNode = (start, xPath, errorMessage) =>
    checkValidNode(start.selectSingle(xPath), errorMessage);

export function getNodes(context, path) {
    return context.selectNodes(path);
}

export function getValidNodeSet(dom, xpath, errorMessage) {
    if (!dom) {
        throw new Error('Starting node is unspecified.');
    }

    const nodes = dom.selectNodes(xpath);

    if (!nodes || nodes.length === 0) {
        throw new Error(errorMessage || errorInvalidPath);
    }

    return nodes;
}

export function deleteNodesCollection(nodes) {
    if (!nodes || nodes.length === 0) {
        return 0;
    }

    for (const node of nodes) {
        if (node) {
            node.deleteSelf();
        }
    }

    return nodes.length;
}

// Returns the number of nodes deleted
// DataSourceNode -> String -> Number
export const deleteNodes = (dom, xpath) => {
    const selectedNodes = dom.selectNodes(xpath);

    return deleteNodesCollection(selectedNodes);
};

// Returns the number of nodes deleted
// DataSourceNode -> Number
export const removeChildren = (node) => {
    return deleteNodesCollection(node.childNodes());
};

// DataSourceNode -> void
export const setNil = (dsNode) => {
    if (!dsNode) {
        return;
    }

    const domNode = dsNode.getNode();

    if (!isElement(domNode)) {
        throw new Error('Cannot set nil on non-element node.');
    }

    const currentValue = domNode.getAttributeNS(nsXsi, 'nil');

    if (currentValue === 'true') {
        return;
    }

    removeChildren(dsNode);

    try {
        domNode.setAttributeNS(nsXsi, 'xsi:nil', 'true');
    } catch (e) {
        console.error('Error in setNil()', e);
    }
};

// DataSourceNode -> DataSourceNode
export const getPi = (dom, name) => {
    const escapedName = name.replace(/"/g, '&quot;');

    return dom.selectSingle(
        `/processing-instruction()[local-name() = "${escapedName}"]`,
    );
};

// (String, String) -> DataSourceNode
export const removePi = (dataSources, name, dsName) => {
    const dom = getDataSource(dataSources, dsName);
    let pi = getPi(dom, name);

    if (pi) {
        pi.deleteSelf();

        return true;
    }

    return false;
};

export const setNodeValueAsync = async (dsNode, valueObject) => {
    if (!dsNode) {
        return;
    }

    let value = valueObject;

    if (typeof valueObject === 'boolean') {
        value = value ? 'true' : 'false';
    }

    await dsNode.setValueAsync(value);
};

export function selectAndSetNodeValueAsync(dsNode, xPath, valueObject) {
    var selectedNode = dsNode.selectSingle(xPath);

    return setNodeValueAsync(selectedNode, valueObject);
}

export function setNodeListValueFromXPathEngine(
    xPathEngine,
    context,
    xPath,
    value,
) {
    var nodeList = selectNodeListFromXPathEngine(xPathEngine, context, xPath);

    nodeList.forEach(function (nodeItem) {
        setNodeValue(nodeItem, value);
    });
}

// (DataSourceCollection, String) -> String
export const getDataSourceContents = (dataSources, dsName) => {
    const ds = getDataSource(dataSources, dsName);

    return xmlToString(ds.getNode());
};
